import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import './game-ui-system.css'
import './gn/gn.css'
import { configureDevBrowserModeFromUrl } from './devBrowser'
import { initializeTelegramWebApp } from './telegram'

configureDevBrowserModeFromUrl()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

initializeTelegramWebApp()
